/* Phatstix — SHARED PRODUCT GALLERY behaviour (snippets/ph-gallery.liquid).
   ONE carousel for every PDP: sections/ph-pdp-buybox.liquid and sections/ph-merch-pdp.liquid.
   Slide state, chevrons (colour follows the photo behind them), the desktop thumb rail, mobile
   swipe, and — when the snippet was given a model_url — the 3D slide at position 1 and its lazy
   mount through window.phMV (assets/ph-mv-lazy.js, which MUST load first).
   Idempotent per node and re-runs on shopify:section:load, so the theme editor is safe. */
(function () {
  if (window.__phGal) return;
  window.__phGal = true;

  function init(gal) {
    if (!gal || gal.__phGal) return;
    gal.__phGal = true;

    var stage   = gal.querySelector('.ph-gal__stage');
    var slide3d = gal.querySelector('[data-ph-gal-3dslide]');
    var thumb3d = gal.querySelector('[data-ph-gal-3dthumb]');

    /* WebGL gate. No 3D on this device (no/old WebGL, reduced motion, weak GPU, ?no3d): the 3D
       slide and its thumb come OUT and every remaining thumb's data-go shifts down one, so photo
       1 becomes slide 0 and the gallery is an ordinary photo carousel. Nothing is ever fetched. */
    if (slide3d && (!window.phMV || !window.phMV.ok)) {
      slide3d.parentNode.removeChild(slide3d);
      if (thumb3d && thumb3d.parentNode) thumb3d.parentNode.removeChild(thumb3d);
      slide3d = null; thumb3d = null;
      gal.classList.remove('ph-gal--3d');
      [].forEach.call(gal.querySelectorAll('.ph-gal__thumb'), function (t) {
        var g = (parseInt(t.getAttribute('data-go'), 10) || 0) - 1;
        t.setAttribute('data-go', String(g < 0 ? 0 : g));
      });
      var f = gal.querySelector('.ph-gal__slide'); if (f) f.classList.add('is-active');
      var ft = gal.querySelector('.ph-gal__thumb'); if (ft) { ft.classList.add('is-active'); ft.setAttribute('aria-current', 'true'); }
      var thumbRail = gal.querySelector('.ph-gal__thumbs');
      if (thumbRail) thumbRail.style.setProperty('--ph-gal-thumb-cols', String(gal.querySelectorAll('.ph-gal__thumb').length));
    }

    var slides = [].slice.call(gal.querySelectorAll('.ph-gal__slide'));
    var thumbs = [].slice.call(gal.querySelectorAll('.ph-gal__thumb'));
    var rail   = gal.querySelector('.ph-gal__thumbs');
    if (!slides.length) return;
    var cur = -1;

    /* Chevron tone. Sampled from a SEPARATE 32px probe image, never the visible one: crossOrigin
       has to be set before load, and setting it on the real <img> would break the photo outright
       if the CDN ever stopped sending CORS headers. Any failure falls back to the light tone. */
    var toneCache = {};
    function applyTone(t) { gal.setAttribute('data-tone-prev', t[0]); gal.setAttribute('data-tone-next', t[1]); }
    function setTone(i) {
      if (toneCache[i]) { applyTone(toneCache[i]); return; }
      var img = slides[i] && slides[i].querySelector('img');
      var src = img && (img.currentSrc || img.getAttribute('src'));
      if (!src) { applyTone(['light', 'light']); return; }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var t = ['light', 'light'];
        try {
          var N = 32, c = document.createElement('canvas'); c.width = N; c.height = N;
          var x = c.getContext('2d'); x.drawImage(probe, 0, 0, N, N);
          var d = x.getImageData(0, 0, N, N).data;
          var band = [[0, Math.round(N * 0.22)], [Math.round(N * 0.78), N]];   /* left edge, right edge */
          for (var b = 0; b < 2; b++) {
            var sum = 0, n = 0;
            for (var y = 0; y < N; y++) for (var px = band[b][0]; px < band[b][1]; px++) {
              var k = (y * N + px) * 4; if (d[k + 3] < 8) continue;            /* transparent reads as page white */
              sum += 0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2]; n++;
            }
            t[b] = (n && (sum / n) < 128) ? 'dark' : 'light';
          }
        } catch (e) { /* tainted canvas: keep the light default */ }
        toneCache[i] = t; applyTone(t);
      };
      probe.onerror = function () { toneCache[i] = ['light', 'light']; applyTone(toneCache[i]); };
      probe.src = src.indexOf('width=') > -1 ? src.replace(/width=\d+/, 'width=32') : src;
    }

    /* mark() only sets state; go() also scrolls. They stay apart because the stage's own scroll
       handler calls mark() — calling go() there would scroll the stage again and fight the swipe. */
    function mark(i) {
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      if (rail && thumbs[i] && rail.scrollWidth > rail.clientWidth + 1) {
        var t = thumbs[i], l = t.offsetLeft, r = l + t.offsetWidth;
        if (l < rail.scrollLeft) rail.scrollTo({ left: l - 8, behavior: 'smooth' });
        else if (r > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: r - rail.clientWidth + 8, behavior: 'smooth' });
      }
      if (i === cur) return;
      cur = i;
      gal.setAttribute('data-cur', String(i));
      setTone(i);
      slides.forEach(function (sl, n) { sl.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t) {
        var on = (parseInt(t.getAttribute('data-go'), 10) || 0) === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function go(i) {
      mark(i);
      if (!window.matchMedia('(min-width:1024px)').matches && slides[i]) {
        slides[i].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }

    [].forEach.call(gal.querySelectorAll('[data-ph-gal-nav]'), function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.getAttribute('data-ph-gal-nav'), 10) || 1;
        var n = cur + d;
        if (n < 0) n = slides.length - 1;                 /* wrap, so neither chevron is ever dead */
        if (n > slides.length - 1) n = 0;
        go(n);
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-go'), 10) || 0); });
    });
    /* Divide by the PAINTED slide, not the scrollport: the stage carries a gap, so clientWidth is
       wider than a slide and the quotient drifts a whole index by the sixth image — the Next arrow
       went dead and the wrong thumb lit. */
    if (stage) stage.addEventListener('scroll', function () {
      var sw = (slides[0] && slides[0].offsetWidth) || stage.clientWidth;
      if (sw) mark(Math.round(stage.scrollLeft / sw));
    }, { passive: true });

    mark(0);

    /* ---- 3D -------------------------------------------------------------------------------- */
    var host = gal.querySelector('[data-ph-gal-3d]');
    var tpl  = gal.querySelector('[data-ph-gal-mvtpl]');
    if (!host || !tpl || !window.phMV || !window.phMV.ok) return;

    var loader  = gal.querySelector('.ph-gal__loader');
    var bar     = gal.querySelector('.ph-gal__ringbar');
    var cue     = gal.querySelector('[data-ph-gal-cue]');
    var catcher = gal.querySelector('.ph-gal__dragcatch');
    if (cue) cue.hidden = false;

    var current = null, rafId = null, hasLoaded = false;
    function resetLoader() { if (loader) loader.classList.remove('is-done'); if (bar) bar.style.strokeDashoffset = '289'; }
    function runLoader(mv) {
      if (rafId) cancelAnimationFrame(rafId);            /* kill any prior loop (fast scroll in/out) */
      var loaded = !!mv.loaded, fin = false, t0 = null;
      mv.addEventListener('load', function () { loaded = true; hasLoaded = true; }, { once: true });
      function done() { if (loader) loader.classList.add('is-done'); }
      function tick(now) {
        if (t0 === null) t0 = now;
        var k = Math.min(1, (now - t0) / 1200);
        var p = Math.min(1 - Math.pow(1 - k, 2.2), loaded ? 1 : 0.99);
        if (bar) bar.style.strokeDashoffset = (289 * (1 - p)).toFixed(1);
        if (p >= 1 || (now - t0) > 8000) { if (!fin) { fin = true; setTimeout(done, 200); } return; }
        rafId = requestAnimationFrame(tick);
      }
      rafId = requestAnimationFrame(tick);
    }

    /* Touch: horizontal drag spins the model, vertical still scrolls the page (pan-y catcher).
       auto-rotate goes BACK ON at pointer-up. It has to: idle:false below means the idle parker
       is not running, so nothing else would ever restart it and one drag would stop the model for
       good. Thom wants this one turning continuously. */
    if (catcher && window.matchMedia && window.matchMedia('(hover: none)').matches) {
      var on = false, x0 = 0, th = 0, phi = 90, rad = '2m';
      catcher.addEventListener('pointerdown', function (e) {
        if (!current) return;
        on = true; x0 = e.clientX;
        try { var o = current.getCameraOrbit(); th = o.theta * 180 / Math.PI; phi = o.phi * 180 / Math.PI; rad = o.radius + 'm'; } catch (err) {}
        current.autoRotate = false; current.removeAttribute('auto-rotate');
      });
      catcher.addEventListener('pointermove', function (e) {
        if (!on || !current) return;
        try { current.cameraOrbit = (th + (e.clientX - x0) * 0.5) + 'deg ' + phi + 'deg ' + rad; if (current.jumpCameraToGoal) current.jumpCameraToGoal(); } catch (err) {}
      });
      var off = function () {
        if (!on) return;
        on = false;
        if (!current) return;
        try { current.setAttribute('auto-rotate', ''); current.autoRotate = true; } catch (err) {}
      };
      catcher.addEventListener('pointerup', off);
      catcher.addEventListener('pointercancel', off);
      catcher.addEventListener('pointerleave', off);
    }

    window.phMV.register({
      host: host,
      rootMargin: '400px 0px',
      /* idle:false = never park on idle. The model turns for as long as it is mounted; the
         IntersectionObserver in ph-mv-lazy.js still DESTROYS it the moment it leaves the viewport,
         and the tab-hide park still fires, so "continuous" costs nothing off-screen or in a hidden
         tab. Thom, 30 Aug 2026 — deliberately against the site's usual rule, and scoped to this
         one registration so ph-hero and ph-merch keep their 4s park. */
      idle: false,
      build: function () { var mv = tpl.content.firstElementChild.cloneNode(true); host.insertBefore(mv, loader || null); return mv; },
      onAttach: function (mv) {
        current = mv;
        if (hasLoaded) { if (loader) loader.classList.add('is-done'); }   /* cached re-entry: skip the % theatre */
        else { resetLoader(); runLoader(mv); }
      },
      onDetach: function () { current = null; if (rafId) cancelAnimationFrame(rafId); }
    });
  }

  function initAll(root) { [].forEach.call((root || document).querySelectorAll('[data-ph-gal]'), init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();